import { useContext } from 'react';

import LoginContext from '../../../aurr/contexts/LoginContext';
import { BOOKMARKS_DESIGNATION } from '../constants';

export const getBookmarksCollectionId = (userId?: string) => {
  const { userProfile } = useContext(LoginContext);
  const oxygenId = userId || userProfile?.sub || '';

  if (!oxygenId) return '';

  return `${oxygenId}::${BOOKMARKS_DESIGNATION}`;
};
